export default "__VITE_ASSET__sJyJ_hwy__"